import * as MdIcons from "react-icons/md";
import { IconBaseProps } from "react-icons/lib";

export interface IconProps extends IconBaseProps {
  name: keyof typeof MdIcons;
}

const Icon: React.FC<IconProps> = ({ name, ...props }) => {
  const IconComponent = MdIcons[name];

  if (!IconComponent) {
    // console.warn(`Ícono "${name}" no encontrado en react-icons/md`);
    return null;
  }

  return <IconComponent {...props} />;
};

export default Icon;
